import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled from 'styled-components';
import { Box, Section, Image, Video, Star, Link } from '@miro-site/core';
import { ButtonAdapter, LazyImageAdapter, Headline, Content } from '@miro-site/components_utils';
import ButtonWithInput from './ButtonWithInput';
import G2Image from './assets/G2';
import CapterraImage from './assets/Capterra';
import GetAppImage from './assets/GetApp';
import { useAnalytics } from '@miro-site/analytics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled(Box).attrs({
  $styles: {
    maxWidth: [null, null, 1200],
    flexDirection: ['column', null]
  },
  $mx: 'auto',
  $px: [16, 40]
}).withConfig({
  displayName: "HeroWithLogos__Container",
  componentId: "sc-lo8o1e-0"
})(["display:flex;"]);
var ContentContainer = styled(Box).withConfig({
  displayName: "HeroWithLogos__ContentContainer",
  componentId: "sc-lo8o1e-1"
})(["flex-grow:1;"]);
var ImageContainer = styled(Box).attrs({
  $ml: [null, 40],
  $styles: {
    flexBasis: [null, 640]
  }
}).withConfig({
  displayName: "HeroWithLogos__ImageContainer",
  componentId: "sc-lo8o1e-2"
})(["flex-shrink:0;flex-grow:0;"]);
var ButtonWrapper = styled(Box).attrs({
  $mt: [24, 32]
}).withConfig({
  displayName: "HeroWithLogos__ButtonWrapper",
  componentId: "sc-lo8o1e-3"
})(["text-align:left;position:relative;"]);
var Clients = styled(Box).attrs({
  $mb: [32, null],
  $styles: {
    height: 48
  }
}).withConfig({
  displayName: "HeroWithLogos__Clients",
  componentId: "sc-lo8o1e-4"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:center;"]);
var ClientDescription = styled(Box).attrs({
  $as: 'span',
  $styles: {
    fontWeight: [700, 500],
    fontSize: [14, 18],
    lineHeight: 24,
    letterSpacing: [null, -0.25]
  }
}).withConfig({
  displayName: "HeroWithLogos__ClientDescription",
  componentId: "sc-lo8o1e-5"
})(["white-space:nowrap;flex-grow:0;"]);
var RatingsContainer = styled(Box).attrs({
  $styles: {
    maxWidth: ['100%', '350px']
  }
}).withConfig({
  displayName: "HeroWithLogos__RatingsContainer",
  componentId: "sc-lo8o1e-6"
})(["display:flex;background:#f5f5f7;border-radius:8px;padding:14px;font-weight:400;font-size:11px;line-height:15px;margin-bottom:24px;"]);
var RatingsLeftContentContainer = styled(Box).attrs({
  $styles: {
    width: ['min-content', 'min-content', null]
  }
}).withConfig({
  displayName: "HeroWithLogos__RatingsLeftContentContainer",
  componentId: "sc-lo8o1e-7"
})([""]);
var StarsContainer = styled(Box).attrs({
  $styles: {
    height: ['13px', '15px']
  }
}).withConfig({
  displayName: "HeroWithLogos__StarsContainer",
  componentId: "sc-lo8o1e-8"
})(["display:flex;margin-bottom:2px;svg{margin-right:6px;height:inherit;}"]);
var RatingAppsContainer = styled(Box).withConfig({
  displayName: "HeroWithLogos__RatingAppsContainer",
  componentId: "sc-lo8o1e-9"
})(["display:flex;flex-grow:1;align-items:center;justify-content:space-evenly;.focus-trap{display:flex;align-items:center;}svg{cursor:pointer;}"]);
var ClientLogo = styled(Box).attrs(function (_ref) {
  var $hideOnMobile = _ref.$hideOnMobile;
  return {
    $as: 'span',
    $ml: 20,
    $styles: {
      display: [$hideOnMobile ? 'none' : 'inline-block', 'inline-block']
    }
  };
}).withConfig({
  displayName: "HeroWithLogos__ClientLogo",
  componentId: "sc-lo8o1e-10"
})(["flex-grow:1;word-break:break-all;"]);
var VideoSection = styled(Box).attrs({
  $styles: {
    paddingTop: '52.67%',
    position: 'relative'
  }
}).withConfig({
  displayName: "HeroWithLogos__VideoSection",
  componentId: "sc-lo8o1e-11"
})([""]);
var VideoWrapper = styled(Box).attrs({
  $styles: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
}).withConfig({
  displayName: "HeroWithLogos__VideoWrapper",
  componentId: "sc-lo8o1e-12"
})([""]);

var HeroWithLogos = function HeroWithLogos(_ref2) {
  var _clients$logos;

  var image = _ref2.image,
      headline = _ref2.headline,
      description = _ref2.description,
      button = _ref2.button,
      subtitle = _ref2.subtitle,
      clients = _ref2.clients,
      video = _ref2.video;
  var analytics = useAnalytics();

  var handleRatingsOnclick = function handleRatingsOnclick(socialApp) {
    return function () {
      analytics.sendCustomEvent('ELH020-SOCIAL-CLICK', {
        type: socialApp
      });
    };
  };

  return /*#__PURE__*/_jsx(Section, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsxs(ContentContainer, {
        children: [/*#__PURE__*/_jsx(Headline, _objectSpread({}, headline)), subtitle && /*#__PURE__*/_jsx(Content, _objectSpread(_objectSpread({}, subtitle), {}, {
          size: "small",
          color: "dark",
          textProps: {
            $mt: [10, 16],
            $styles: {
              opacity: ['0.6', '0.72']
            }
          }
        })), button.inputCTA ? /*#__PURE__*/_jsx(ButtonWithInput, {
          inputCTA: button.inputCTA,
          href: button.href,
          className: button["class"],
          testId: "button-with-input-cta",
          $buttonType: "primary",
          $withArrow: true,
          children: button.text
        }) : /*#__PURE__*/_jsx(ButtonWrapper, {
          children: /*#__PURE__*/_jsx(ButtonAdapter, _objectSpread(_objectSpread({}, button), {}, {
            type: "blue",
            arrow: true
          }))
        }), /*#__PURE__*/_jsx(Content, _objectSpread(_objectSpread({}, description), {}, {
          size: "tiny",
          color: "dark",
          textProps: {
            $mt: 8,
            $mb: [32, 40],
            $styles: {
              opacity: '0.4'
            }
          }
        })), clients.ratingWidget ? /*#__PURE__*/_jsxs(RatingsContainer, {
          children: [/*#__PURE__*/_jsxs(RatingsLeftContentContainer, {
            children: [/*#__PURE__*/_jsxs(StarsContainer, {
              children: [/*#__PURE__*/_jsx(Star, {
                color: "#FF9D48"
              }), /*#__PURE__*/_jsx(Star, {
                color: "#FF9D48"
              }), /*#__PURE__*/_jsx(Star, {
                color: "#FF9D48"
              }), /*#__PURE__*/_jsx(Star, {
                color: "#FF9D48"
              }), /*#__PURE__*/_jsx(Star, {
                halfStar: true,
                color: "#FF9D48"
              })]
            }), /*#__PURE__*/_jsx("div", {
              children: "Based on 5149+ reviews:"
            })]
          }), /*#__PURE__*/_jsxs(RatingAppsContainer, {
            children: [/*#__PURE__*/_jsx(Link, {
              onClick: handleRatingsOnclick('G2'),
              href: "https://www.g2.com/products/miro/reviews",
              children: /*#__PURE__*/_jsx(G2Image, {})
            }), /*#__PURE__*/_jsx(Link, {
              onClick: handleRatingsOnclick('GetApp'),
              href: "https://www.getapp.com/collaboration-software/a/miro/",
              children: /*#__PURE__*/_jsx(GetAppImage, {})
            }), /*#__PURE__*/_jsx(Link, {
              onClick: handleRatingsOnclick('Capterra'),
              href: "https://www.capterra.com/p/128955/Miro/",
              children: /*#__PURE__*/_jsx(CapterraImage, {})
            })]
          })]
        }) : /*#__PURE__*/_jsxs(Clients, {
          children: [/*#__PURE__*/_jsx(ClientDescription, {
            children: clients.description
          }), (_clients$logos = clients.logos) === null || _clients$logos === void 0 ? void 0 : _clients$logos.slice(0, 4).map(function (logo, index) {
            return /*#__PURE__*/_jsx(ClientLogo, {
              $hideOnMobile: logo.hideOnMobile,
              children: /*#__PURE__*/_jsx(Image, {
                src: logo.src,
                name: logo.alt
              })
            }, index);
          })]
        })]
      }), /*#__PURE__*/_jsxs(ImageContainer, {
        children: [image && /*#__PURE__*/_jsx(LazyImageAdapter, {
          assets: image
        }), video && /*#__PURE__*/_jsx(VideoSection, {
          children: /*#__PURE__*/_jsx(VideoWrapper, {
            children: /*#__PURE__*/_jsx(Video, _objectSpread({}, video))
          })
        })]
      })]
    })
  });
};

export default HeroWithLogos;